// The bell's list: the latest notifications, read or unread, the unread
// marked. Nothing in it is swiped and closing it marks nothing read; a row
// opens what it is about.
import { Spinner, cx } from "@/platform/ui";
import { PanelHeader, PanelRow, type PanelItem } from "@/notifications/ui/panel.js";
import { UnreadDot } from "@/notifications/ui/presenters.js";

interface ListItem extends PanelItem {
  unread: boolean;
}

export function NotificationList({
  className,
  unread,
  items,
  loading,
  onMarkAllRead,
  onSeeAll,
}: {
  /** Where the list sits. */
  className: string;
  /** How many are unread, of all of them. */
  unread: number;
  items: ListItem[];
  loading?: boolean;
  onMarkAllRead(): void;
  onSeeAll(): void;
}) {
  return (
    <div
      className={cx(
        "overflow-hidden rounded-xl border border-line bg-surface shadow-2xl",
        className,
      )}
    >
      <PanelHeader
        label="Mark all read"
        onAction={onMarkAllRead}
        actionDisabled={unread === 0}
        onSeeAll={onSeeAll}
      />
      <div className="max-h-[60dvh] divide-y divide-line/60 overflow-y-auto">
        {loading ? (
          <div className="flex justify-center py-6">
            <Spinner />
          </div>
        ) : items.length === 0 ? (
          <div className="py-6 text-center text-xs font-semibold text-faint">No notifications</div>
        ) : (
          items.map((item) => (
            <PanelRow
              key={item.id}
              item={item}
              unread={item.unread}
              aside={item.unread ? <UnreadDot /> : null}
            />
          ))
        )}
      </div>
    </div>
  );
}
